import Typography from "@mui/material/Typography";
import type { FilterChip } from "../../types";
import {
  defaultUploadedAccountsSlice,
  type UploadedAccountsSlice,
} from "./slice";

/**
 * Generates chips for the uploaded accounts filter.
 * Only shows chip when in SUCCESS state with valid data.
 */
export function getChips(
  slice: UploadedAccountsSlice,
  setSlice: (slice: UploadedAccountsSlice) => void
): FilterChip[] {
  // Only show chip in SUCCESS state
  if (slice.uploadState !== "SUCCESS" || !slice.fileId) {
    return [];
  }

  const matched = slice.matchedRows ?? 0;
  const total = slice.totalRows ?? 0;
  const invalid = slice.invalidRows ?? 0;

  const tooltipContent = (
    <>
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: 500, color: "#424242", mb: 0.5 }}
      >
        Uploaded Accounts
      </Typography>
      {slice.fileName && (
        <Typography
          variant="body2"
          sx={{ fontSize: 12, color: "#666", py: 0.25 }}
        >
          File: {slice.fileName}
        </Typography>
      )}
      <Typography
        variant="body2"
        sx={{ fontSize: 12, color: "#666", py: 0.25 }}
      >
        Matched: {matched} of {total}
      </Typography>
      {invalid > 0 && (
        <Typography
          variant="body2"
          sx={{ fontSize: 12, color: "#666", py: 0.25 }}
        >
          Invalid rows: {invalid}
        </Typography>
      )}
    </>
  );

  return [
    {
      id: "uploadedAccounts",
      label: `Uploaded Accounts: ${matched} of ${total} matched`,
      filterKey: "uploadedAccounts" as const,
      onRemove: () => setSlice(defaultUploadedAccountsSlice),
      tooltipContent,
    },
  ];
}

/**
 * Returns count for sidebar badge.
 * Returns 1 if filter is active (SUCCESS state), 0 otherwise.
 */
export function getCount(slice: UploadedAccountsSlice): number {
  return slice.uploadState === "SUCCESS" && slice.fileId ? 1 : 0;
}
